import { css } from '@emotion/css';

import { colors } from '@ajaibid/components';

export const styPrimeWrapper = css`
  border-radius: 12px;
  border: 1px solid ${colors.NEUTRAL_2};
  margin: 50px 16px 0;
`;

export const styPrimeHeader = css`
  background: ${colors.SLATE_GRAY_7};
  padding: 10px 16px;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  height: 40px;
`;

export const styPrimeContent = css`
  padding: 12px 16px;
  border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const styPrimeManager = css`
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-flow: column;
  margin-left: 12px;
`;

export const styPrimeText = css`
  font-size: 12px;
`;

export const styPrimeName = css`
  font-size: 14px;
  font-weight: bold;
`;

export const styPrimeRightHeader = css`
  display: flex;
  align-items: center;
`;

export const styPrimeBadgeTrial = css`
  color: ${colors.NEUTRAL_0};
  font-size: 10px;
  background: ${colors.SLATE_GRAY_6};
  padding: 4px 8px;
  border-radius: 64px;
  font-weight: bold;
`;

export const styPrimeTrialInfo = css`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  margin-left: 8px;
`;

export const styPrimeTrialTitle = css`
  font-weight: bold;
  line-height: 20px;
  font-size: 12px;
`;

export const styMembershipModal = css`
  text-align: left;
  div > h3 {
    font-size: 12px;
    color: #707070;
    > strong {
      font-size: 16px;
      display: flex;
      color: #333333;
    }
  }
  div > ol {
    list-style: none;
    padding: 0;
    margin-top: 16px;
    > li {
      font-size: 12px;
      > h4 {
        font-size: 12px;
        margin: 8px 0;
      }
      > p {
        margin-bottom: 4px;
        > strong {
          margin-bottom: 4px;
        }
      }
    }
  }
`;
